import React from "react";
import { renderMain } from "../base";
import { Main } from "./main";
import { SSRDataProvider } from "../../providers/ssr-data-provider";

renderMain(
  <SSRDataProvider value={{ pathname: location.pathname }}>
    <Main />
  </SSRDataProvider>
);
